
export function DemoHeroSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            See Driscop in Action
          </h1>
          <p className="text-xl text-gray-400 mb-8 leading-relaxed">
            Preview our next-generation AI cybersecurity platform in development for UK SMEs. Explore early concepts for threat detection, dashboard design, and training features that will protect businesses from phishing and smishing attacks.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-medium hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-play-fill mr-2"></i>
              Preview Concept Demo
            </button>
            <button className="border border-blue-400 text-blue-400 px-8 py-4 rounded-lg text-lg font-medium hover:bg-blue-500/100/20 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-calendar-line mr-2"></i>
              Join Beta Program
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
